module.exports = function getResource(label, vars = []) {
    let resources = {
        myBasketLabel: 'My Basket'
    };

    return resources[label];
};
